import { RootState } from "@/store/store";
import { alertsDataSelector } from "@/store/alerts/selectors/common/data/alertsDataSelector";

export const alertsUtilizationDataProviderSelector = (state: RootState) => {
  const alertsData = alertsDataSelector(state);
  return alertsData.provider;
};
